import { useState } from 'react'
import { useProject } from '../stores/ProjectContext'
import './HelpModal.css'
import './ProjectsModal.css'

export default function ProjectsModal({ isOpen, onClose }) {
  const { savedProjects, loadProjectFromDatabase, deleteProjectFromDatabase } = useProject()
  const [loading, setLoading] = useState(false)

  if (!isOpen) return null

  const handleLoadProject = async (projectId) => {
    setLoading(true)
    const result = await loadProjectFromDatabase(projectId)
    setLoading(false)
    if (result.success) {
      onClose()
    } else {
      alert(`Failed to load project: ${result.error}`)
    }
  }

  const handleDeleteProject = async (projectId, projectName) => {
    if (!confirm(`Delete project "${projectName}"? This cannot be undone.`)) {
      return
    }

    setLoading(true)
    const result = await deleteProjectFromDatabase(projectId)
    setLoading(false)
    if (!result.success) {
      alert(`Failed to delete project: ${result.error}`)
    }
  }

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    })
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-container projects-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Your Projects</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>

        <div className="modal-body">
          {savedProjects.length === 0 ? (
            <div className="empty-state">
              <p>You don't have any saved projects yet.</p>
              <p>Click "Save" in the File menu to save your current project.</p>
            </div>
          ) : (
            <div className="projects-list">
              {savedProjects.map((proj) => (
                <div key={proj._id} className="project-item">
                  <div className="project-info">
                    <h3>{proj.name}</h3>
                    {proj.description && <p className="project-description">{proj.description}</p>}
                    <p className="project-meta">
                      Last updated: {formatDate(proj.updatedAt || proj.createdAt)}
                    </p>
                  </div>
                  <div className="project-actions">
                    <button
                      className="button-primary"
                      onClick={() => handleLoadProject(proj._id)}
                      disabled={loading}
                    >
                      Open
                    </button>
                    <button
                      className="button-danger"
                      onClick={() => handleDeleteProject(proj._id, proj.name)}
                      disabled={loading}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="modal-footer">
          <button onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  )
}
